import { Box, makeStyles } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import React from "react";

const useStyles = makeStyles(() => {
  return {
    progressLoader: {
      color: '#ffffff',
    },
    loader: {
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      zIndex: 0,
    },
  };
});

export default () => {
  const classes = useStyles();
  return (
    <Grid
      container={true}
      alignItems="center"
      justifyContent="center"
      style={{ height: "100%" }}
    >
      {/* <CircularProgress className={classes.progressLoader} size="3rem" />
       */}
      <Box className={classes.loader} position="absolute">
        <CircularProgress
          size="3rem"
          className={classes.progressLoader}
        />
      </Box>
    </Grid>
  );
};



// WEBPACK FOOTER //
// ./src/components/LoadingGrid.tsx